module.exports = __webpack_public_path__ + "static/media/Mobi-Wash.3b5fcfe2.svg";